import { Directive } from '@angular/core';
import { FlexOffsetDirective as FlexLayoutFlexOffsetDirective } from '@angular/flex-layout';

const inputs = [
  'flLayoutFlexOffset',
  'flLayoutFlexOffset.mobile',
  'flLayoutFlexOffset.tablet',
  'flLayoutFlexOffset.desktop-small',
  'flLayoutFlexOffset.desktop-large',
  'flLayoutFlexOffset.desktop-xlarge',
  'flLayoutFlexOffset.desktop-xxlarge',
];

@Directive({
  selector: `
    [flLayoutFlexOffset],
    [flLayoutFlexOffset.mobile],
    [flLayoutFlexOffset.tablet],
    [flLayoutFlexOffset.desktop-small],
    [flLayoutFlexOffset.desktop-large],
    [flLayoutFlexOffset.desktop-xlarge],
    [flLayoutFlexOffset.desktop-xxlarge],
  `,
  inputs,
})
export class FlexOffsetDirective extends FlexLayoutFlexOffsetDirective {
  protected inputs = inputs;
}
